module.exports = __webpack_public_path__ + "datahub/img/nested.c948fb38.svg";